// ST-1258 -Claude- Singleton Nearrme API client for the web app.
// Reads VITE_API_URL at build time. Telemetry hooks call backend /telemetry endpoints.

import { createNearrmeClient, type NearrmeClient } from '@nearrme/api-client';
import { getConsumerToken } from '../auth/session';

const baseUrl = import.meta.env.VITE_API_URL ?? 'https://app-nearrme-api-dev.azurewebsites.net';

let _client: NearrmeClient | null = null;

export function getApiClient(): NearrmeClient {
  if (_client) return _client;
  _client = createNearrmeClient({
    baseUrl,
    getAuthToken: getConsumerToken,
    getDeviceHeaders: () => ({
      'X-App-Id': 'nearrme-web',
      'X-Platform': 'web',
      'X-Locale': navigator.language,
      'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      'X-Color-Scheme': document.documentElement.classList.contains('dark') ? 'dark' : 'light',
      'X-Screen-Size': `${window.innerWidth}x${window.innerHeight}`,
    }),
    onError: (error, url) => {
      // ST-1290 -Claude- Per the no-eat-errors rule, log every failure prominently in dev.
      // In production this will fire telemetry to backend /api/v2/consumer/telemetry/error.
      console.error('[Nearrme API error]', url, error);
    },
  });
  return _client;
}
